import React, { createContext, useContext, useCallback, useMemo } from 'react';
import { translations } from '../translations/translations';
import { useLanguage } from './LanguageContext';
import {
  resolveTranslation,
  hasTranslation,
  FALLBACK_LANGUAGE,
} from '../i18n/resolve';

const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
  const { language } = useLanguage();

  const t = useCallback(
    (key, params) => resolveTranslation(translations, language, key, params),
    [language]
  );

  const tHasKey = useCallback(
    (key) => hasTranslation(translations, language, key),
    [language]
  );

  const value = useMemo(
    () => ({
      t,
      tHasKey,
      currentLanguage: language,
      fallbackLanguage: FALLBACK_LANGUAGE,
    }),
    [t, tHasKey, language]
  );

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
};

export default TranslationContext;
